const systemRoutes = [
    {
        path:'index',
        name:'system-index',
        component: () => import(/* webpackChunkName: "about" */ '@/views/system/index.vue')
    },
    {
        path:'qrcode',
        name:'system-qrcode',
        component: () => import(/* webpackChunkName: "about" */ '@/views/system/scanQRcode.vue')
    },
    {
        path:'dementia_introduce',
        name:'system-dementia_introduce',
        component: () => import(/* webpackChunkName: "about" */ '@/views/system/dementia_introduce.vue')
    },
    {
        path:'therapist_recommend',
        name:'system-therapist_recommend',
        component: () => import(/* webpackChunkName: "about" */ '@/views/system/therapist_recommend.vue')
    },
    
    
  ]
  export default systemRoutes